import type { ICustomControlRequestReadProps } from '../../interfaces/customControlRequestReadProps';
import { ProcessEntity } from '../../../../../../common/enums/processEntity';
import { FormDivider, FormParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { ProfessionalSummaryDataRead } from '../../../professionalSummaryData/ProfessionalSummaryDataRead';
import { MedicationsRead } from '../../utils/v1/medications/MedicationsRead';
import { TxcsMedicationsList } from '../../utils/v1/TxcsMedicationsList';

export function RequestSummaryNsi(props: ICustomControlRequestReadProps) {
    return (
        <>
            {props.request.customControlData.verwijsreden && (
                <HorizontalFormGroupRead>
                    <FormLabel>Verwijsreden</FormLabel>
                    <InputContainer>
                        <FormParagraph>{props.request.customControlData.verwijsreden}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
            <HorizontalFormGroupRead>
                <FormLabel>Relevante klachten</FormLabel>
                <InputContainer>
                    <FormParagraph>{getRelevanteKlachtenNsi()}</FormParagraph>
                </InputContainer>
            </HorizontalFormGroupRead>

            <FormDivider />

            <MedicationsRead
                entity={ProcessEntity.request}
                entityId={props.request.id}
                patientUsesMedication={props.request.patientUsesMedication}
            />
            <ProfessionalSummaryDataRead request={props.request} />

            <TxcsMedicationsList requestId={props.request.id} />
        </>
    );

    function getRelevanteKlachtenNsi() {
        const checkedRelevanteKlachten: string[] = [];

        Object.keys(props.request.customControlData.relevante_klachten).forEach((key) => {
            if (props.request.customControlData.relevante_klachten[key] === true) {
                checkedRelevanteKlachten.push(relevanteKlachtenLabels[key]);
            } else if (typeof props.request.customControlData.relevante_klachten[key] === 'string') {
                checkedRelevanteKlachten.push(props.request.customControlData.relevante_klachten[key]);
            }
        });

        return checkedRelevanteKlachten.join(', ');
    }
}

const relevanteKlachtenLabels: { [key: string]: string } = {
    vermoeidheid_overdag: 'vermoeidheid overdag',
    verminderde_concentratie: 'verminderde concentratie',
    stokkende_ademhaling_tijdens_de_slaap: 'stokkende ademhaling tijdens de slaap',
    veel_snurken: 'veel snurken',
    niet_verfrissende_slaap: 'niet-verfrissende slaap',
    meer_dan_5_ademstops_per_uur: 'meer dan 5 ademstops per uur (>10 seconden per ademstop)',
};
